import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LangRouterLink } from '@pyg-directives/lang-router-link.directive';
import { GetDemoComponent } from '@pyg-shared/get-demo/get-demo.component';
import { GetInfoComponent } from '@pyg-shared/get-info/get-info.component';

@Component({
  selector: 'app-in-store',
  templateUrl: './in-store.component.html',
  styleUrls: ['./in-store.component.scss'],
  imports: [TranslatePipe, GetDemoComponent, GetInfoComponent, LangRouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InStoreComponent {}
